var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"wrapper"},[_vm._v("\n    "+_vm._s(_vm.content)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }